"use client";
import * as React from "react";
const SvgInfoSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m.8 12H7.2V7.2h1.6zm0-6.4H7.2V4h1.6z" }));
export {
  SvgInfoSharp as default
};
